module.exports = __webpack_public_path__ + "img/AvatarBeary.784fc3be.png";